import React, { Component } from 'react';
import _memoize from 'lodash.memoize';
import { ConfirmationModal } from '@shootsta/common-react';
import getMasterOutput from '../../../utils/getMasterOutput';

function getSubtitle(text: string, organisationName: string) {
  return (
    <span>
      {text}
      <strong>{organisationName}</strong>.
    </span>
  );
}

type ArchiveModalProps = {
  visible: boolean;
  archiveOutput: any;
  unarchiveOutput: any;
  onConfirmation: any;
  onClose: any;
  video?: Video;
  organisationName: string;
  isShowArchived: boolean;
};

export default class ArchiveModal extends Component<ArchiveModalProps> {
  handleActionRequest = _memoize((actionRequest: any) => async () => {
    const { video, onConfirmation } = this.props;

    if (!video) {
      return null;
    }

    const output = getMasterOutput(video);

    const { data, error } = await actionRequest(output && output.outputId);

    if (!data || error) {
      return null;
    }

    return onConfirmation();
  });

  getModalProps = () => {
    const { isShowArchived, archiveOutput, unarchiveOutput, organisationName } =
      this.props;

    return isShowArchived
      ? {
          onSave: this.handleActionRequest(unarchiveOutput),
          subtitle: getSubtitle(
            'Unarchiving this output will make this visible for everyone within ',
            organisationName
          )
        }
      : {
          onSave: this.handleActionRequest(archiveOutput),
          subtitle: getSubtitle(
            'Archiving this output will make this hidden from view from everyone within ',
            organisationName
          )
        };
  };

  render() {
    const { visible, onClose } = this.props;

    return (
      <ConfirmationModal
        visible={visible}
        onClose={onClose}
        title="Are you sure?"
        saveBtnText="Continue"
        {...this.getModalProps()}
      />
    );
  }
}
